/**
 * @description
 * @author Kody
 * @date 2018-11-27
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

import IInput from './models/input';
import IOutput from './models/output';

export const recordShareTheme = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.RECORD_SHARE_THEME, data).then((res: IResponse<IOutput>) => {
        return res.data;
    });
};
